
<template>
    <div class="Client">
        <div class="title">
            <div class="BigTitle">{{ $t("Learn.client") }}</div>
            <div class="SubTitle">{{ $t("Learn.whatClient") }}</div>
            <div class="detail">
                <div>
                    {{ $t("Learn.interest1") }}
                </div>
                <div>
                    {{ $t("Learn.interest2") }}
                </div>
            </div>
        </div>

        <div class="content">
            <div class="adv">
                <div class="intro l">
                    <img class="img1" src="../../../assets/m/intro/Abnormal.png">
                </div>
                <div class="intro">
                    <div class="describe"><img  class="img2" src="../../../assets/m/intro/Stakingfre.png" ></div>
                    <div class="describe k"><img class="img3" src="../../../assets/m/intro/Security.png"></div>
                </div>
            </div>
            <div class="box-card">
                <div class="item">
                    <div class="introT">{{ $t("Learn.interest3") }}</div>
                    <div class="introD">{{ $t("Learn.detail3") }}</div>
                </div>
                <div class="item">
                    <div class="introT">{{ $t("Learn.interest4") }}</div>
                    <div class="introD">{{ $t("Learn.detail4") }}</div>
                </div>
                <div class="item">
                    <div class="introT">{{ $t("Learn.interest5") }}</div>
                    <div class="introD">{{ $t("Learn.detail5") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
  mounted() {
    //this.init();
  },
  destroyed() {
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
    .Client {
        text-align: center;
        margin-top: 110px;
        margin-bottom: 149px;
        width: 100%;
        color: #000000;
        .title {
            text-align: center;
            height: 761px;
            background: url("../../../assets/m/intro/bgi.png") no-repeat center/100%
            100%;
            .BigTitle {
                padding-top: 120px;
                width: 648px;
                font-size: 64px;
                font-weight: 900;
                color: #000000;
                font-family: Poppins-Black, Poppins;
                line-height: 83px;
                margin: 0 auto;
                padding-bottom: 20px;
            }
            .SubTitle {
                font-size: 30px;
                font-weight: 500;
                font-family: Poppins-Medium, Poppins;
                color: #000000;
                line-height: 35px;
                padding-bottom: 20px;
            }
            .detail {
                width: 645px;
                font-size: 26px;
                font-weight: 500;
                font-family: Poppins-Medium, Poppins;
                color: #61666B;
                line-height: 43px;
                margin: 0 auto;
            }
        }
        .content{
            margin-top: -162px;
            /*margin-top: 100px;*/
            text-align: center;
            .adv{
                cursor: pointer;
                width: 650px;
                height: 650px;
                margin: 0 auto;
                text-align: center;
                .img1{
                    width: 326px;
                    height: 325px
                }
                .img2{
                    width: 308px;
                    height: 196px;
                }
                .img3{
                    width: 231px;
                    height: 355px;
                }
            }
            .box-card {
                margin-top: 17px;
                text-align: center;
                .item {
                    cursor: pointer;
                    width: 650px;
                    margin: 0 auto;
                    .introT{
                        font-size: 32px;
                        font-weight: 600;
                        color: #1A1A2C;
                        line-height: 54px;
                        font-family: Poppins-SemiBold, Poppins;
                        margin-top: 36px;
                        margin-bottom: 30px;
                    }
                    .introD{
                        font-size: 28px;
                        font-weight: 500;
                        color: #61666B;
                        font-family: PingFang SC-Medium, PingFang SC;
                        line-height: 46px;
                        margin-bottom: 120px;
                    }
                }
            }
            .intro{
                float: left;
                .k{
                    margin-top: 15px;
                    margin-left: 0;
                    text-align: left;
                }
            }
            .l{
                margin-right: 16px;
            }
        }
    }

</style>
